import React from "react";
import { useAuth } from "@/context/AuthContext";
import AccountSidebar from "@/components/account/AccountSidebar";
import { useNavigate } from "react-router-dom";

export default function Settings() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid lg:grid-cols-[240px_1fr] gap-6">
      <AccountSidebar/>
      <section className="bg-white border border-slate-100 rounded-2xl p-6 space-y-5">
        <h1 className="font-display text-2xl font-bold">Account Settings</h1>
        <Row k="Email" v={user?.email}/>
        <Row k="Account Type" v={user?.role}/>
        <Row k="Auth Provider" v={user?.auth_provider || "local"}/>
        <button data-testid="settings-logout" onClick={async()=>{await logout(); nav("/");}} className="border border-red-200 text-red-600 px-5 py-2 rounded-full text-sm font-semibold">Logout</button>
      </section>
    </main>
  );
}
function Row({k,v}){return <div className="flex justify-between py-2 border-b border-slate-100 last:border-0 text-sm"><span className="text-slate-500">{k}</span><span className="font-medium">{v}</span></div>;}
